module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row10_havefun.ae05fd5f.png";